export default {
    namespaced: true,
    state: {
		title: '',
		params: {},
        data: {},
    },
}